import { space } from '@joykit/variables/space';
import { ColumnGap, Screen } from './../types';
import { Interpolation } from 'emotion';
import { variables } from '../variables';

export namespace mixins {
  export const getGapFactor = (columnGap: ColumnGap) => {
    const gap = space.values.toPx[columnGap] || space.values.toPx.default;
    const gapFactor = 2 * gap;
    return gapFactor;
  };

  const buildMediaQuery = (screen: Screen, gapFactor: number) => {
    switch (screen) {
      case 'mobile':
        return `@media screen and (max-width: ${variables.breakpointsByScreen.mobile}px)`;
      case 'tablet':
        return `@media screen and (min-width: ${variables.breakpointsByScreen.tablet}px)`;
      case 'desktop':
        return `@media screen and (min-width: ${variables.breakpointsByScreen.desktop + gapFactor}px)`;
      case 'widescreen':
        return `@media screen and (min-width: ${variables.breakpointsByScreen.widescreen + gapFactor}px)`;

      default:
        return null;
    }
  };
  export const getMediaQueryForScreen = (screen: Screen, gapFactor: number, rules: Interpolation) => {
    const mediaQuery = buildMediaQuery(screen, gapFactor);
    return mediaQuery ? { [mediaQuery]: rules } : null;
  };
}
